var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (ngif) {
      pug_mixins["bigbox"] = pug_interp = function(keys, addClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ('bav' === keys) {
ngif = 'ExtrainfoCtrl.employee.data.insurances.bav.beitrag'
}
else {
if ('string' === typeof keys) {
keys = [keys]
}
// iterate keys
;(function(){
  var $$obj = keys;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
keys[index] = 'ExtrainfoCtrl.componentKeys.indexOf("'+ val + '") > -1'
    }
  }
}).call(this);

ngif = keys.join(' || ')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["bigbox","centered",addClass], [false,false,true]), false, true)+pug.attr("ng-if", ngif, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["bigbox"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EBAV\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "ExtrainfoCtrl.neoExtras.bavbegin","title": "Beginn der BAV","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie das Beginndatum der BAV an.","parse":"Bitte Datum im Format tt.mm.jjjj eingeben"},"attributes": {"vn-date":"true"}}
});
pug_html = pug_html + "\u003Cp class=\"small\" ng-if=\"ExtrainfoCtrl.bavNotification\"\u003EAktuell gespeicherts Datum {{ ExtrainfoCtrl.bavNotification | date}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--.row(ng-if='ExtrainfoCtrl.iAmAdvisor'): .columns+select(\n  key= 'ExtrainfoCtrl.neoExtras.intversicherer'\n  title= 'Wahl des Versicherers'\n  required\n  validationMessages= {\n    required: 'W�hlen Sie eine Versicherung aus'\n  }\n  attributes={\n    'ng-options': 'insurance.id as insurance.firma for insurance in ExtrainfoCtrl.insurances'\n  }\n)\n--\u003E\u003Cdiv class=\"form-group schema-form-submit continue-margin-top\" ng-hide=\"neoDocuments\"\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"ExtrainfoCtrl.proceed()\" ng-disabled=\"ExtrainfoCtrl.busy || ExtrainfoCtrl.needMail\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'bav', 'bav');
    }.call(this, "ngif" in locals_for_with ?
        locals_for_with.ngif :
        typeof ngif !== 'undefined' ? ngif : undefined));
    ;;return pug_html;};
module.exports = template;